import { useEffect, useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { Toast } from 'ui/components'

import { api } from '../../../../api'
import { GetResetUrlPayload, ResetUrlResponse, SendResetUrlPayload } from '../../../../types'
import { ResetPasswordProps } from './ResetPassword.types'

export const useResetPassword = (props: ResetPasswordProps) => {
  const { user, onClose } = props
  const [url, setUrl] = useState('')

  const { mutateAsync: getResetUrl } = useMutation<ResetUrlResponse, Error, GetResetUrlPayload>({
    mutationFn: api.getResetUrl,
    onSuccess: async ({ url }) => {
      setUrl(url)
    },
    onError: (error) => Toast.errorSmall(error.message)
  })

  const sendResetUrl = useMutation<unknown, Error, SendResetUrlPayload>({
    mutationFn: api.sendResetUrl,
    onSuccess: async () => {
      Toast.success('Success', 'The password reset link has been sent to the user’s email')
      onClose()
    },
    onError: (error) => Toast.errorSmall(error.message)
  })

  useEffect(() => {
    if (user) {
      getResetUrl({ userId: user.id })
    }
  }, [getResetUrl, user])

  const sendResetEmail = () => {
    if (url && user) {
      sendResetUrl.mutateAsync({
        url,
        login: user.email
      })
    }
  }

  return {
    url,
    sendResetEmail
  }
}
